export const makeAccessibleName = (issuerName: string, lastFour: string) =>
  `${issuerName} ending in ${lastFour}`
